<template>
  <transition name="fade">
    <v-form @submit.prevent="checkForm">
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="motivo"
              label="Motivo"
              placeholder="Descripción del motivo"
              :error-messages="errors.motivo"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="end">
          <v-btn color="red" @click="$emit('toggle', false)" class="mr-2">
            Cancelar
          </v-btn>
          <v-btn color="green" type="submit"> Guardar </v-btn>
        </v-row>
      </v-container>
    </v-form>
    <!-- <form v-if="false" class="ui form" @submit="checkForm">
      <div class="field required">
        <label
          >Motivo
          <div v-if="errors.motivo" class="ui left pointing red basic label">
            {{ errors.motivo }}
          </div>
        </label>
        <input
          type="text"
          v-model="motivo"
          placeholder="Descripción del motivo"
        />
      </div>

      <button style="float: right" class="ui button positive" type="submit">
        Guardar
      </button>
      <button
        style="float: right"
        @click="$emit('toggle', false)"
        class="ui button"
        type="button"
      >
        Cancelar
      </button>
    </form> -->
  </transition>
</template>

<style>
.select2-container {
  width: 100% !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
export default {
  name: "MotivoForm",
  components: {},
  props: ["edit", "dataEdit", "loadData"],
  data() {
    return {
      motivo: "",
      searchText: "",
      proveedorNombre: "",
      keyformProv: 1,
      proveedor: " ",
      factura: "",
      serie: "",
      folio: "",
      showModalPro: false,
      errors: {},
      loader: true,
      facturas: [],
      proveedorArray: [],
    };
  },
  methods: {
    async searchProveedor(searchText) {
      if (searchText != "") {
        this.proveedorArray = [];
        searchText = searchText.toUpperCase();

        const data = await this.$store.getters.getFirebaseApp.database
          .ref("AMC/Provedores")
          .orderByChild("NAME~~RFC")
          .startAt(searchText)
          .endAt(searchText + "\uf8ff")
          .once("value");
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.proveedorArray.push({
              id: element[0],
              Nombre: element[1]["nom"],
            });
          });
        }
      }

      /*let categorias = [];
        arrayCate.forEach(function(element){
            categorias.push({id:element[0],Nombre:element[1]['Nombre']}); 
        });
        this.Categories = categorias;*/
      //CONF/Catalogo/PDV/Productos/Facturas
    },
    getDetail(productoId) {
      let producto = this.getProductoById(productoId);
      this.actualExist = producto.Existencia;
      this.nombre = producto.Nombre;
      this.actualPrice = producto.Precio;
      this.newPrice = producto.Precio;
      this.codigo = producto.Codigo;
      this.actualMoneda = producto.Moneda;
    },
    getProductoById(code) {
      let itemIndex = this.$_.findIndex(this.products, { id: code });
      if (itemIndex >= 0) {
        return this.products[itemIndex];
      }

      return false;
    },

    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      if (!this.motivo) {
        this.errors.motivo = "El motivo es obligatorio";
        valid = false;
      } else {
        this.errors.motivo = false;
      }

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }

        this.$emit("successData", this.$data, doAction);
      }
    },
  },
  computed: {
    comp_fact() {
      let prod = [
        { id: " ", text: "Seleccione una factura" },
        { id: "535435435", text: "10000 - MR MECHANIC PRO" },
        { id: "535435467", text: "20005 - NIKE" },
        { id: "5354354675", text: "30007 - ADIDAS" },
      ];

      return prod;
    },

    comp_prov() {
      let prov = [];
      this.proveedorArray.forEach((element) => {
        prov.push({ value: element.id, text: element.Nombre });
      });

      return prov;
    },
  },
  watch: {
    producto: function (val) {
      this.getDetail(val);
    },
  },
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    if (this.edit) {
      this.nombre = this.dataEdit.Nombre;
    }
    if (this.loadData) {
      this.producto = this.loadData.ProductoId;
    }
  },
};
</script>
